import { GRID_VARIANT } from "@helpers/plasmic/slices";

import {
  FILTER_OPTIONS,
  OTHER_LINK_TYPE,
  URL_TYPE_OPTIONS,
} from "@stadium/shared/src/constants/stores/routes";

export const CE_09_SliceProps = {
  spans: {
    type: "object",
    fields: {
      columns: {
        type: "number",
      },
      tabletColumns: {
        type: "number",
      },
      mobileColumns: {
        type: "number",
      },
    },
    hidden: (props) => !GRID_VARIANT.includes(props.variant),
  },
  banners: {
    type: "array",
    description: "Banner names are prefixed with the position.",
    forceRemount: true,
    helpText:
      "The position should be unique and should not be repeated.\n\nIf position is repeated, the first banner with that position will be displayed.",
    hidden: (props) => !GRID_VARIANT.includes(props.variant),
    itemType: {
      type: "object",
      nameFunc: (item) => (item.title ? `[${item.position}] ${item?.title}` : "Banner"),
      fields: {
        image: {
          type: "imageUrl",
          required: true,
        },
        imageMobile: {
          type: "imageUrl",
          helpText:
            "Image shown on mobile (below md breakpoint). Falls back to desktop image if unset.",
        },
        imageTablet: {
          type: "imageUrl",
          helpText:
            "Image shown on tablet (md to lg breakpoint). Falls back to desktop image if unset.",
        },
        urlType: {
          type: "choice",
          options: URL_TYPE_OPTIONS,
          defaultValue: OTHER_LINK_TYPE,
        },
        filterOptions: {
          type: "choice",
          options: FILTER_OPTIONS,
        },
        linkToNewTab: {
          type: "boolean",
          defaultValue: false,
        },
        otherUrl: {
          type: "string",
          helpText: "Need to select 'urlType' as 'Other' to make this url work.",
        },
        code: {
          type: "string",
          helpText: "Category slug to display in the banner.",
          defaultValue: "",
        },
        title: {
          type: "string",
          defaultValue: "Banner",
          required: true,
        },
        span: {
          type: "number",
          required: true,
          defaultValue: 1,
          description: "Number of columns this banner spans on desktop.",
        },
        spanTablet: {
          type: "number",
          required: true,
          defaultValue: 1,
          description: "Number of columns this banner spans on tablet.",
        },
        spanMobile: {
          type: "number",
          required: true,
          defaultValue: 1,
          description: "Number of columns this banner spans on mobile.",
        },
        position: {
          type: "number",
          required: true,
          defaultValue: 0,
          description: "Position of the banner in the grid.",
          helpText: "The position should be unique and should not be repeated.",
        },
      },
    },
    defaultValue: [],
  },
};
